module.exports = __webpack_public_path__ + "static/media/right-arrow.99b26ad9.svg";